// Service worker registration + install-prompt helper.
// Keeps wiring isolated from React. Safe no-op in unsupported browsers / SSR / dev.

let deferredPrompt = null;
const listeners = new Set();

function notify() {
  const installable = !!deferredPrompt;
  listeners.forEach((cb) => {
    try { cb(installable); } catch { /* ignore */ }
  });
}

export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;
  // Only register in production builds — dev (webpack-dev-server) and CRA hot reload
  // don't play well with an active SW cache layer.
  if (process.env.NODE_ENV !== "production") return;

  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").catch(() => { /* ignore — offline-first is best-effort */ });
  });

  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferredPrompt = e;
    notify();
  });

  window.addEventListener("appinstalled", () => {
    deferredPrompt = null;
    notify();
  });
}

export function onInstallable(cb) {
  listeners.add(cb);
  // Fire immediately with current state
  cb(!!deferredPrompt);
  return () => listeners.delete(cb);
}

export async function promptInstall() {
  if (!deferredPrompt) return { outcome: "unavailable" };
  const evt = deferredPrompt;
  deferredPrompt = null;
  notify();
  evt.prompt();
  const choice = await evt.userChoice;
  return choice; // { outcome: "accepted" | "dismissed" }
}
